import { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import UploadForm from './upload_form';
import '../../../css/data-grid.css';

function FileUploadEtc_popup() {

    const [data, setData] = useState([]);
    const [list, setList] = useState([]);
    const [atchDta, setAtchDta] = useState([]);
    const [head, setHead] = useState([]);
    const [excelData, setExcelData] = useState({});
    const [output, setOutput] = useState([]);
    const [checked, setChecked] = useState('');
    const [replace, setReplace] = useState([]);
    const [changed, setChanged] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('tableData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/excel_upload_resource.do', {
                params: {
                    tableName: sendData.tableName,
                    tableOwner: sendData.tableOwner,
                }
            });
            setData(response.data);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    const callList = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/selectNewSubjList.do', { params: { subType: "etc" } });
            setList(response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    }

    const isValidDate = (dateStr, format = 'YYYYMMDD') => {
        if (!/^\d{8}$/.test(dateStr)) return false;
        const year = parseInt(dateStr.substring(0, 4));
        const month = parseInt(dateStr.substring(4, 6));
        const day = parseInt(dateStr.substring(6, 8));
        const date = new Date(year, month - 1, day);
        return (
            date.getFullYear() === year &&
            date.getMonth() + 1 === month &&
            date.getDate() === day
        );
    };

    const isValidDate2 = (dateStr) => {
        console.log(!/^\d{8}$/.test(dateStr));
        console.log(!dateStr.includes('-'));
        if (!/^\d{6}-\d{1}$/.test(dateStr)) {
            return false;
        }
        return dateStr;
    };

    const uploadCheckValidation = (rowData, rowIndex) => {
        try {
            const getValue = (col) => (rowData[col] || '').toString().trim();
            const OnlyNumpattern = /^[0-9]+$/;

            let [
                sbjectCd, nm, resiRegNo, lcnsCd,
                lcnsNo, lcnsRegDt,
                crdtBeginDt, crdtEndDt,
                endReason, lbcstAt,
                lbcstBeginDt, lbcstEndDt,
                squardYn, aisEduYn, aisEduDt, crdtInitDt, bigo
            ] = [
                'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q'
            ].map(getValue);

            const rowIdx = rowIndex + 1;
            const isEmpty = (value) => !value || value.replace(/\s/g, "") === "";
            const stripDash = (value) => value?.replace(/-/g, '');

            if (isEmpty(sbjectCd)) {
                alert((rowIdx) + "번째 행이 잘못 입력됐습니다. 전문과목 항목은 필수값입니다.");
                return false;
            }

            if (isEmpty(nm)) {
                alert((rowIdx) + "번째 행이 잘못 입력됐습니다. 성명은 필수값입니다.");
                return false;
            }

            if (!isEmpty(resiRegNo)) {
                if (!isValidDate2(resiRegNo)) {
                    alert((rowIdx) + "번째 행이 잘못 입력됐습니다.\n생년월일을 다시 입력해주세요. (ex920709-1)");
                    return false;
                }
            } else {
                alert((rowIdx) + "번째 행이 잘못 입력됐습니다. 생년월일은 필수값입니다.");
                return false;
            }

            if (isEmpty(lcnsNo)) {
                if (sbjectCd != '행정') {
                    alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\면허(자격) 번호는 필수값입니다.");
                    return false;
                }
            }
            if (isEmpty(lcnsRegDt)) {
                if (lcnsRegDt) {
                    lcnsRegDt = stripDash(lcnsRegDt);
                }
                if (!OnlyNumpattern.test(lcnsRegDt)) {
                    alert((rowIdx) + "번째 행이 잘못 입력됐습니다.\n근무 종료일일 입력은 날짜 형식으로 입력되어야 합니다.");
                    return false;
                }
                if (sbjectCd != '행정') {
                    alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\n면허(자격) 취득일은 필수값입니다.");
                    return false;
                }
            }
            if (isEmpty(lcnsCd)) {
                if (sbjectCd != '행정') {
                    alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\n면허 및 자격은 필수값입니다.");
                    return false;
                }
            }

            if (isEmpty(crdtBeginDt)) {
                if (crdtBeginDt) {
                    crdtBeginDt = stripDash(crdtBeginDt);
                }
                if (!OnlyNumpattern.test(crdtBeginDt)) {
                    alert((rowIdx) + "번째 행이 잘못 입력됐습니다.\n근무 종료일일 입력은 날짜 형식으로 입력되어야 합니다.");
                    return false;
                }
                alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\n외상센터 근무 시작일은 필수값입니다.");
                return false;
            }

            if (!isEmpty(crdtEndDt)) {
                if (crdtEndDt) {
                    crdtEndDt = stripDash(crdtEndDt) || crdtBeginDt;
                }
                if (!OnlyNumpattern.test(crdtEndDt)) {
                    alert((rowIdx) + "번째 행이 잘못 입력됐습니다.\n근무 종료일일 입력은 날짜 형식으로 입력되어야 합니다.");
                    return false;
                }
                if (crdtBeginDt > crdtEndDt) {
                    alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\n근무 종료일은 근무 시작일보다 빠를 수 없습니다.");
                    return false;
                }
                if (isEmpty(endReason)) {
                    alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\n근무 종료일 입력 시 근무 종료사유는 필수값입니다.");
                    return false;
                }
            }

            if (isEmpty(squardYn)) {
                alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\n전담여부는 필수값입니다.");
                return false;
            }

            if (isEmpty(aisEduYn)) {
                alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\nAIS 코딩 교육 이수 여부은 필수값입니다.");
                return false;
            } else if (aisEduYn == 'Y' && (isEmpty(aisEduDt))) {
                alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\nAIS 코딩 교육 여부가 Y라면 AIS 코딩 교육 이수일을 입력해야합니다.");
                return false;
            } else if (aisEduYn == 'M') {
                aisEduDt = stripDash(aisEduDt);
                if (!OnlyNumpattern.test(aisEduDt)) {
                    alert((rowIdx) + "번째 행이 잘못 입력됐습니다. AIS 코딩 교육 이수일은 날짜 형식으로 입력되어야 합니다.");
                    return false;
                }

                if (!isEmpty(aisEduDt)) {
                    alert((rowIdx) + "번째 추가행이 잘못 입력됐습니다.\nAIS 코딩 교육 여부가 Y일 때만 AIS 코딩 교육 이수일을 입력할 수 있습니다.");
                    return false;
                }
            }

            if (lbcstAt == '국비' || lbcstAt == 'Y') {
                if (!isEmpty(lbcstBeginDt)) {
                    if (lbcstBeginDt.includes('/')) {
                        alert((rowIdx) + "번째 행이 잘못 입력됐습니다. 국비수당 지원 시작일 입력에서 '/'는 사용할 수 없는 문자입니다.");
                        return false;
                    }
                    if (lbcstBeginDt) {
                        lbcstBeginDt = stripDash(lbcstBeginDt);
                    }
                    if (!OnlyNumpattern.test(lbcstBeginDt)) {
                        alert((rowIdx) + "번째 행이 잘못 입력됐습니다. 국비수당 지원 시작일 입력은 날짜 형식으로 입력되어야 합니다.");
                        return false;
                    }
                    if (lbcstEndDt) {
                        lbcstEndDt = stripDash(lbcstEndDt) || lbcstBeginDt;
                    }
                    if (lbcstBeginDt > lbcstEndDt) {
                        alert((rowIdx) + "번째 행이 잘못 입력됐습니다. 국비수당 지원 종료일은 국비수당 지원 시작일보다 먼저일 수 없습니다.");
                        return false;
                    }
                    if (!isValidDate(lbcstBeginDt, 'YYYYMMDD')) {
                        alert((rowIdx) + "번째 행이 잘못 입력됐습니다.\n국비수당 지원 시작일을 입력해주세요.")
                        return false;
                    }
                }
            }
            return true;
        } catch (e) {
            alert(e.message);
            return false;
        }
    };

    const formatDate = (val) => {
        if (!val || val.length !== 8) return val;
        return `${val.substring(0, 4)}-${val.substring(4, 6)}-${val.substring(6, 8)}`;
    };

    const uploadReplaceValue = (row) => {
        try {
            const newRow = { ...row };

            newRow.F = formatDate(newRow.F) || ''; // 외상센터 근무 시작일
            newRow.G = formatDate(newRow.G) || ''; // 외상센터 근무 시작일
            newRow.H = formatDate(newRow.H) || ''; // 외상센터 근무 종료일
            newRow.M = formatDate(newRow.M) || ''; // 전담전문의 근무 시작일
            newRow.N = formatDate(newRow.N) || ''; // 전담전문의 근무 종료일
            newRow.O = formatDate(newRow.O) || ''; // 국비지급 시작일자
            newRow.P = formatDate(newRow.P) || ''; // 국비지급 종료일자
            return newRow;
        } catch (e) {
            console.error('uploadReplaceValue error:', e);
            alert(`[uploadReplaceValue] 오류: ${e.message}`);
            return row;
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files[0] !== undefined) {
            setAtchDta(e.target.files[0]); //TF로 변경
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = (evt) => {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'base64' });
                const headers = {};
                Object.keys(wb.SheetNames).forEach((i) => {
                    const wsname = wb.SheetNames[i];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                    return headers[wsname] = data[0];
                });
                setChecked(wb.SheetNames[0]);
                setOutput(wb.SheetNames[0]);
                setHead(headers);
                setExcelData(to_json(wb));
                console.log(to_json(wb));
            };
            reader.readAsArrayBuffer(file);
        } else {
            setAtchDta([]);
            setHead([]);
            setExcelData([]);
            setOutput([]);
            setChecked('');
            setChanged([]);
            return;
        }
    };

    const to_json = (workbook) => {
        const result = {};
        workbook.SheetNames.forEach((sn) => {
            const sheet = workbook.Sheets[sn];
            const rows = XLSX.utils.sheet_to_json(sheet, {
                header: 'A',     // 첫 행을 header로 사용
                defval: '',
            });
            if (rows.length > 0) {
                result[sn] = rows;
            }
        });
        return result;
    };

    const initChanged = (head, data) => {
        if (head === undefined) {
            return;
        } else {
            const mapped = head.reduce((acc, row, idx) => {
                const key = String.fromCharCode(65 + idx);
                const item = data.find(item => item.COMMENTS === row);
                const value = item ? item.COLUMN_NAME : '';
                acc[key] = value;
                return acc;
            }, {});
            setChanged(mapped);
        };
    }

    const save = async () => {
        if (atchDta.length === 0) {
            alert('선택된 파일이 없습니다.');
            return false;
        }
        if (changedValid(changed) === 'T') {
            alert('중복 선택한 항목이 있습니다. ');
            return false;
        }
        const real = replace.map((row) => ({
            ...row,
            A: list.filter((i) => i.CD_NM === row.A).map(item => item.CD)[0]
        }))
        real.unshift(changed);
        saveLogic(real, "/trmsapi/obthrc/new_excel_upload_etc.do");
    };

    const saveLogic = async (data, url) => {
        const payload = new URLSearchParams({
            emogcode: sendData.emogCode,
            excData: JSON.stringify(data),
            userId: localStorage.getItem("id"),
        });

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: payload,
            });

            if (!response.ok) {
                throw new Error(`서버 오류: ${response.status}`);
            }

            const resultText = await response.text();
            console.log('저장 결과:', resultText);

            alert('저장이 완료되었습니다.');
        } catch (error) {
            console.error('저장 중 오류 발생:', error);
            alert('저장에 실패했습니다. 관리자에게 문의하세요.');
        }
    }

    const exit = () => {
        window.close();
    }

    const handelOptions = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...changed,
            [name]: value
        };
        setChanged(newParams);
    };

    const changedValid = (change) => {
        var result = 'F';
        var length = head[checked].length
        for (var i = 0; i < length; i++) {
            var key = change[String.fromCharCode(65 + i)];
            if (Object.values(change).filter((i) => key === i).length > 1) {
                result = 'T';
                break;
            }
        }
        return result;
    }

    useEffect(() => {
        popupData();
        callList();
    }, []);

    useEffect(() => {
        initChanged(head[checked], data);
        const currentSheet = excelData[checked];
        console.log(currentSheet);
        if (!currentSheet || !Array.isArray(currentSheet)) {
            setReplace([]);
            return;
        }
        var flag = 'N';
        const processed = currentSheet.slice(1).map((row, Idx) => {
            if (!uploadCheckValidation(row, Idx)) flag = 'Y';
            return uploadReplaceValue(row);
        });
        setReplace(flag === 'N' ? processed : []);
    }, [excelData]);

    return (
        <UploadForm
            atchDta={atchDta}
            handleFileChange={handleFileChange}
            setChecked={setChecked}
            checked={checked}
            output={output}
            sendData={sendData}
            excelData={excelData}
            replace={replace}
            head={head}
            data={data}
            handelOptions={handelOptions}
            save={save}
            exit={exit}
            title={"기타"}
            changed={changed}
        />
    );
}


export default FileUploadEtc_popup;